export function vjs_find(e, i) {
  return e.querySelector(i)
}

export function vjs_mfind(e, i) {
  return e.querySelectorAll(i)
}

export function vjs_El(type, className, innerHTML) {
  const element = document.createElement(type)
  if (className) {
    element.className = className
  }
  if (innerHTML) {
    element.innerHTML = innerHTML
  }

  return element
}

export function setIcon(el, icon) {
  if (el) {
    const t = el.querySelector('.vjs-svg-icon use')
    if (t) {
      t.setAttribute('href', `#vjs-icon-${icon}`)
    }
  }
}
